import styled from '@emotion/styled';
import {md, sm} from '../../variables.styles';

interface ControlButtonProps {
  round: boolean;
  full: boolean;
}

export const Container = styled.div`
  position: relative;
`;

export const ControlButton = styled.button<ControlButtonProps>`
  padding: 0;
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 250ms ease;

  ${({round}) => round && 'border-radius: 6px;'}
  ${({full}) =>
    full &&
    `
    width: 100%;
    height: 100%;
  `}

  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px #63b3ed, 0 0 3px 1px #63b3ed;
  }

  &:hover {
    opacity: 0.75;
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  bottom: calc(100% + ${md} + ${sm});
  left: 50%;
`;
